import React from "react";

/**
 * @component PinIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <PinIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PinIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="PinIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M2.585 5.739c-.78.78-.78 2.044 0 2.824l5.367 5.367.77 3.585a.993.993 0 00.705.756 1 1 0 00.98-.256l3.098-3.098 4.79 4.79a.998.998 0 101.412-1.412l-4.79-4.79 3.098-3.098a.99.99 0 00.291-.638.991.991 0 00-.253-.736.994.994 0 00-.545-.312l-3.578-.769-5.367-5.367a1.997 1.997 0 00-2.824 0L2.585 5.739zm12.723 4.552l-1.797-.386a1.997 1.997 0 01-.993-.54L7.151 3.996 3.997 7.151l5.367 5.367c.272.272.46.617.54.993l.387 1.796 5.016-5.016z"
        clipRule="evenodd"
      />
    </svg>
  )
);
PinIcon.displayName = "PinIcon";
export default PinIcon;
